import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { UnidadeMedida } from '../types/UnidadeMedida.type';

@Injectable({
  providedIn: 'root'
})
export class UnidademedidaService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getAll() {
      return this.httpClient.get<UnidadeMedida[]>(this.configService.getApiUrlRoot() + "/unidademedidas/");
    }

  exportar(){
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/unidademedidas/relatorios/exportar`, { responseType: 'blob'})
  }
}
